import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { ComponentsModule, DirectiveModule, PhonePrefixService, PipesModule } from '@fcom/common';
import { GtmModule } from '@fcom/common/gtm';
import { LoginModule } from '@fcom/common/login';
import { CorporateService } from '@fcom/common/services/corporate/corporate.service';
import { RefundsCommonModule } from '@fcom/refunds-common/refunds-common.module';
import { RefundsService } from '@fcom/refunds-common/services/refunds.service';
import { CommonServiceFormsModule } from '@fcom/service-forms/components/common/common-service-forms.module';
import { ServiceFormsModule } from '@fcom/service-forms/service-forms.module';
import { UiComponentsModule } from '@fcom/ui-components';
import { UiTranslateModule } from '@fcom/ui-translate';
import { CommonBookingComponentsModule } from '@fcom/common-booking';

import {
  BaggageTracingFormComponent,
  CancellationCoverClaimFormComponent,
  CaseAttachmentsFormComponent,
  CertificatesForInsuranceCompanyFormComponent,
  ClaimMissingPartnerPointsFormComponent,
  ClaimMissingPointsFormComponent,
  CorporateContactFormComponent,
  ETicketReceiptFormComponent,
  FormBuilderComponent,
  GiftCardInformationFormComponent,
  JoinCorporateFormComponent,
  LoggedInMissingPointsFormComponent,
  LoggedOutMissingPointsFormComponent,
  RefundFormComponent,
  RefundStatusCheckerFormComponent,
  SafDownloadFormComponent,
  SpecialAssistanceFormComponent,
  SpecialAssistanceWizardComponent,
  VatReceiptFormComponent,
} from './components';
import { BaggageTracingService } from './services/baggage-tracing.service';
import { ClaimOrFeedbackService } from './services/claim-or-feedback.service';
import { GiftCardService } from './services/gift-card.service';
import { MissingPointsService } from './services/missing-points.service';
import { SubmitService } from './services/submit.service';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    DirectiveModule,
    GtmModule,
    PipesModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    CommonServiceFormsModule,
    UiComponentsModule,
    UiTranslateModule,
    ServiceFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    RefundsCommonModule,
    CommonBookingComponentsModule,
    LoginModule,
  ],
  declarations: [
    BaggageTracingFormComponent,
    CancellationCoverClaimFormComponent,
    CaseAttachmentsFormComponent,
    CertificatesForInsuranceCompanyFormComponent,
    ClaimMissingPartnerPointsFormComponent,
    ClaimMissingPointsFormComponent,
    CorporateContactFormComponent,
    ETicketReceiptFormComponent,
    FormBuilderComponent,
    GiftCardInformationFormComponent,
    JoinCorporateFormComponent,
    LoggedInMissingPointsFormComponent,
    LoggedOutMissingPointsFormComponent,
    RefundFormComponent,
    RefundStatusCheckerFormComponent,
    SpecialAssistanceFormComponent,
    SpecialAssistanceWizardComponent,
    VatReceiptFormComponent,
    SafDownloadFormComponent,
  ],
  exports: [
    BaggageTracingFormComponent,
    CancellationCoverClaimFormComponent,
    CaseAttachmentsFormComponent,
    CertificatesForInsuranceCompanyFormComponent,
    ClaimMissingPartnerPointsFormComponent,
    ClaimMissingPointsFormComponent,
    ETicketReceiptFormComponent,
    FormBuilderComponent,
    GiftCardInformationFormComponent,
    LoggedInMissingPointsFormComponent,
    LoggedOutMissingPointsFormComponent,
    RefundFormComponent,
    RefundStatusCheckerFormComponent,
    SpecialAssistanceFormComponent,
    SpecialAssistanceWizardComponent,
    VatReceiptFormComponent,
    SafDownloadFormComponent,
  ],
  providers: [
    BaggageTracingService,
    ClaimOrFeedbackService,
    CorporateService,
    CorporateService,
    GiftCardService,
    MissingPointsService,
    PhonePrefixService,
    RefundsService,
    SubmitService,
  ],
})
export class ServiceFormsLazyModule {}
